import { useQuery } from '@tanstack/react-query';
import { KaeuferPlusLegalInsurance } from '@/@types/kaeuferPlusLegalInsurance';
import { getKaeuferPlusLegalInsurance } from '@/api/kaeuferPlusLegalInsurance/getKaeuferPlusLegalInsurance';

export const useKaeuferPlusLegalInsurance = (): {
  initializing: boolean;
  kaeuferPlusLegalInsuranceActivationDate?: string;
  kaeuferPlusLegalInsuranceExpirationDate?: string;
  isKaeuferPlusLegalInsuranceAvailable: boolean;
  isError?: boolean;
} => {
  const { isLoading, isFetching, data, isError } = useQuery<KaeuferPlusLegalInsurance, Error>({
    queryKey: ['kaeuferPlusLegalInsurance'],
    queryFn: getKaeuferPlusLegalInsurance,
  });

  return {
    initializing: isLoading || isFetching,
    kaeuferPlusLegalInsuranceActivationDate: data?.activationDate,
    kaeuferPlusLegalInsuranceExpirationDate: data?.expirationDate,
    isKaeuferPlusLegalInsuranceAvailable: data?.active || false,
    isError: isError,
  };
};
